var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-top": "10px" }
        },
        [
          _c(
            "div",
            { staticClass: "filters" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "50px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("common.btn.query") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "310px" },
                        attrs: {
                          no: "queryInput",
                          placeholder: _vm.$t("common.tips.fuzzySearch")
                        },
                        model: {
                          value: _vm.filter.likeName,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "likeName", $$v)
                          },
                          expression: "filter.likeName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "triggers" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "query", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "new", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "edit", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "delete", size: "mini", type: "danger" },
                  on: { click: _vm.remove }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-grid" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              no: "grid",
              "config-module": "101326",
              "grid-params": _vm.girdParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.girdParams = $event
              },
              "update:grid-params": function($event) {
                _vm.girdParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-pagination" },
        [
          _c("cargo-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0"
              }
            ],
            attrs: {
              no: "pagination",
              total: _vm.total,
              page: _vm.filter.pageNum,
              limit: _vm.filter.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.filter, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.filter, "pageSize", $event)
              },
              pagination: _vm.toQuery
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            "custom-class": "dialogStyle",
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_SequenceNumber") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "serialNumber", disabled: true },
                        model: {
                          value: _vm.editDialog.form.serialNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "serialNumber", $$v)
                          },
                          expression: "editDialog.form.serialNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        required: "",
                        label: _vm.$t("CargoMsg.Cargo_Name")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "code",
                          "show-word-limit": "",
                          maxlength: "35",
                          size: "mini"
                        },
                        model: {
                          value: _vm.editDialog.form.code,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "code", $$v)
                          },
                          expression: "editDialog.form.code"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "remark",
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "200",
                          rows: 3
                        },
                        model: {
                          value: _vm.editDialog.form.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "remark", $$v)
                          },
                          expression: "editDialog.form.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("span", [_vm._v(_vm._s(_vm.editDialog.title))]),
            _c(
              "span",
              {
                staticStyle: {
                  color: "#b0b0b0",
                  margin: "10px",
                  "font-size": "8px"
                }
              },
              [_vm._v(_vm._s(_vm.editDialog.tips))]
            )
          ]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }